import { useTranslation } from "react-i18next";
import { getNewReceivedRequestsFilter } from "../../../../../common/queries";
import EntityTable from "../../../../common/tables/EntityTable";
import useMissionRequestsColumns from "../../../../../hooks/useMissionRequestsColumns";
import MissionRequestResponseDialog from "../../common/MissionRequestResponseDialog";
import { useCallback, useMemo, useState } from "react";
import { Task } from "@emberly/zenith-client";
import { useNavigate } from "react-router";
import { useStation } from "../../../../../providers/StationProvider";
import { ActivityEnums } from "../../../../../common/constants";
import { MakeActivity } from "../../../../../common/activity";

export default function NewRequestsSection(props) {
  const { onRowClick } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [entityId, setEntityId] = useState();
  const [rejectAction, setRejectAction] = useState(null);
  const [acceptAction, setAcceptAction] = useState(null);
  const { station, logEvent } = useStation();

  const onAcceptRequest = useCallback(async (id) => {
    try {
      const t = new Task();

      setEntityId(id);
      setAcceptAction(t);
      let data = await t.wait();

      logEvent(MakeActivity(ActivityEnums.Category.Mission, ActivityEnums.Type.MissionRequestAccepted, data.missionId, "", "", null, data.missionNumber));

      if (data.openMission) {
        setTimeout(() => {
          navigate(`/network/requests/received/accepted/${data.missionId}/1`, { relative: "path" });
        }, 10);
      }

    } catch (err) {
      console.log(err);
    } finally {
      setAcceptAction(null);
    }
  }, [navigate, logEvent]);

  const onRejectRequest = useCallback(async (id) => {
    try {
      setEntityId(id);
      const t = new Task();
      setRejectAction(t);
      const data = await t.wait();
      logEvent(MakeActivity(ActivityEnums.Category.Other, ActivityEnums.Type.MissionRequestRejected, null, "", "", null, data.referenceNumber ));
    } catch (err) {
      console.log(err);
    } finally {
      setRejectAction(null);
    }
  }, [logEvent]);

  const columns = useMissionRequestsColumns(true, onAcceptRequest, onRejectRequest);
  const filter = useMemo(() => getNewReceivedRequestsFilter(station), [station]);


  return !!station ? (
    <>
      <EntityTable
        tableId="new_requests_section"
        type="MissionRequest"
        onRowClick={onRowClick}
        columns={columns}
        filter={filter}
        emptyStateTitle={t("missionRequests:newRequestsSection:emptyStateTitle")}
        emptyStateDescription={t("missionRequests:newRequestsSection:emptyStateDescription")}
        sortDescendingByDefault
        xs={12}
      />

      {
        !!acceptAction ? (
          <MissionRequestResponseDialog
            requestId={entityId}
            action={acceptAction}
            accept
          />
        ) : null
      }

      {
        !!rejectAction ? (
          <MissionRequestResponseDialog
            requestId={entityId}
            action={rejectAction}
            reject
          />
        ) : null
      }
    </>
  ) : null;
}

